
export function isUrlExternal(url) {
  var host = window.location.hostname;

  var linkHost = function(url) {
    if (/^https?:\/\//.test(url)) { // Absolute URL.
      // The easy way to parse an URL, is to create <a> element.
      // @see: https://gist.github.com/jlong/2428561
      var parser = document.createElement('a');
      parser.href = url;

      return parser.hostname;
    }
    else { // Relative URL.
      return window.location.hostname;
    }
  }(url);

  return host !== linkHost;
}

const CONTENT_TYPES = ['info', 'pages', 'pageList', 'main']

export function checkIsError(props, typesToCheck) {
  typesToCheck = !typesToCheck ? CONTENT_TYPES : typesToCheck
  return typesToCheck.reduce((prev, val) => (
    prev || (!!props[val] && !!props[val].status && props[val].status === 'error')
  ), false)
}

export function routeStructBuilder({routes, type='pages', depth=Infinity}) {
  if(!routes && routes.constructor !== Object) return
  const transformedRoutes = childRouteStruct({ routes: routes[0].childRoutes, depth })
  return transformedRoutes && transformedRoutes.children[type] ? transformedRoutes.children[type].children : []
}

function childRouteStruct({ routes, depth }) {
  if(!routes) return
  const checkCreatePathObj = (obj, arr, data={}, curDepth=0) => {
    if(arr.length > 0 && curDepth < depth) {
      const name = arr.shift()
      curDepth++

      const { attributes } = data;

      if(name !== 'index') {
        if(!obj.children[name]) {
          obj.children[name] = {}
        }
        if(arr.length !== 0 && curDepth < depth && (!attributes || !attributes.hidden)) {
          if(!obj.children[name].children) {
            obj.children[name].children = {}
          }
          obj.children[name] = checkCreatePathObj(obj.children[name], arr, data, curDepth)
        } else {
          obj.children[name] = Object.assign(obj.children[name], attributes, {
            url: urlFormatter(data.path, data.suffix) || undefined,
          })
        }
      } else {
        obj = Object.assign(obj, attributes, {
          url: urlFormatter(data.path, data.suffix) || undefined,
        })

      }
    }
    return obj
  }

  return routes.reduce((pre, cur) => {
    cur.path = cur.path.charAt(0) === '/' ? cur.path.slice(1) : cur.path
    let pathArr = cur.path.split('/').filter(p => !!p)
    return checkCreatePathObj(pre, pathArr, cur)
  }, { children: {} })
}

export function urlFormatter(url, suffix) {
  return url !== '/' ? suffix ? `/${url}.${suffix}` : `/${url}` : url
}



// WEBPACK FOOTER //
// ./common/genericHelper.js